export function track(event, extra = {}) {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({ event, url: window.location.href, referrer: document.referrer, ...extra }),
    }).catch(() => {});
  } catch (e) { /* noop */ }
}
